<script>
    import Vue from 'vue'
    import axios from 'axios'
    import {$eBus} from '@/event-bus'
    import GameClientEvent from '@/enum/GameClientEvent'
    import {ConsoleLogger} from '@/console-logger'
    import AppConfig from '@/app-config'
    import GameType from "@/enum/GameType";

    export default {
        name: 'api-client',
        data() {
            return {
                logger: new ConsoleLogger('ApiClient', 'background: #0000aa; color: white', null, AppConfig.debug.api),
                http: null,
                lastResponse: null,
                baseUrlIsSet: false
            }
        },
        created() {
            if (!Vue.prototype.$apiClient) {
                Object.defineProperty(Vue.prototype, '$apiClient', {value: this})

                this.logger.logMessage(`Assigned to Vue.$apiClient`)
            }

            this.http = axios.create({
                timeout: 5000
            })
        },
        methods: {
            request(type, endPoint, onResolve = null, onReject = null) {
                let typePrint = type.toUpperCase()

                this.logger.logMessage(`${typePrint} ${endPoint}`)

                this.http[type](endPoint).then((response) => {
                    this.lastResponse = response;

                    if (response && response.hasOwnProperty('data')) {
                        this.logger.logMessage(`${typePrint} ${endPoint} | SUCCESS`)

                        if (onResolve) {
                            onResolve(response.data)
                        }
                    } else {
                        this.logger.logMessage(`${typePrint} ${endPoint} | ERROR | Could not find any data in response`)

                        if (onReject) {
                            onReject('Could not find any data in response')
                        }
                    }
                }).catch((error) => {
                    if (error.response) {
                        this.lastResponse = error.response;
                    } else {
                        this.lastResponse = null;
                    }

                    // For testing purposes
                    throw error;

                    this.logger.logMessage(`${typePrint} ${endPoint} | ERROR | Could not execute request: ${error}`)

                    if (onReject) {
                        onReject(`Could not execute request: ${error}`)
                    }

                    if (AppConfig.throwApiError) {
                        throw error
                    }
                })
            },
            hasBaseUrlBeenSet() {
                return this.baseUrlIsSet;
            },
            setBaseUrlFromHostPort(host, port, secure) {
                let hostWithPort = `${host}:${port}`;
                let url = (secure ? 'https' : 'http') + '://' + hostWithPort + '/api/';

                this.setBaseUrl(url);
            },
            setBaseUrl(baseUrl) {
                this.logger.logMessage(`Set API base URL to ${baseUrl}`)

                this.baseUrlIsSet = true;

                this.http.defaults.baseURL = baseUrl
            },
            getBaseUrl() {
                return this.http.defaults.baseURL;
            },

            getThemes(gameType, onResolve = null, onReject = null) {
                let _gameType;

                if (gameType === GameType.SinglePlayer) {
                    _gameType = 'singlePlayer';
                } else if (gameType === GameType.SinglePlayer) {
                    _gameType = 'classRoom';
                }

                this.request('get', `/theme?gameType=${_gameType}`, (data) => {
                    if (data.themes) {
                        onResolve(data.themes)
                    } else {
                        onResolve('noThemes')
                    }
                }, onReject)
            },
            getThemesFromRoomId(roomId, onResolve = null, onReject = null) {
                this.request('get', `/room/${roomId}/theme`, (data) => {
                    if (data.themes) {
                        onResolve(data.themes)
                    } else {
                        onResolve('noThemes')
                    }
                }, onReject)
            },

            getThemeCases(themeId, type, onResolve = null, onReject = null) {
                return this.request('get', `/theme/${themeId}/case/${type}`, (data) => {
                    if (data.cases) {
                        onResolve(data.cases)
                    } else {
                        onResolve('noCases')
                    }
                }, onReject)
            },
            getThemeCasesFromRoomId(roomId, themeId, type, onResolve = null, onReject = null) {
                return this.request('get', `/room/${roomId}/theme/${themeId}/case/${type}`, (data) => {
                    if (data.cases) {
                        onResolve(data.cases)
                    } else {
                        onResolve('noCases')
                    }
                }, onReject)
            },

            getTheme(themeId, onResolve = null, onReject = null) {
                this.request('get', `/theme/${themeId}`, (data) => {
                    if (data.theme) {
                        onResolve(data.theme)
                    } else {
                        onReject(`noTheme`)
                    }
                }, onReject)
            },

            getCase(themeId, caseId, onResolve = null, onReject = null) {
                this.request('get', `/theme/${themeId}/case/${caseId}`, (data) => {
                    if (data.case) {
                        console.log('RESOLVE!')

                        onResolve(data.case)
                    } else {
                        onReject('caseEmpty')
                    }
                }, onReject)
            },
            isRoomJoinable(roomId, onResolve = null, onReject = null) {
                this.request('get', `/room/${roomId}/joinable`, (data) => {
                    if (data.joinable) {
                        onResolve()
                    } else {
                        onReject('notJoinable:' + (data.error || 'Unknown error'))
                    }
                }, onReject)
            },
            getAvailableRoomId(onResolve = null, onReject = null) {
                this.request('get', `/room/availableId`, (data) => {
                    if (data.roomId) {
                        onResolve(data.roomId)
                    } else {
                        onReject('noRoomId')
                    }
                }, onReject)
            }
        },
        render: function (h) {
            return h() // avoid warning message
        }
    }
</script>